(function () {
	'use strict';

	angular
        .module('app')
        .factory('UrlService', UrlService);

	UrlService.$inject = ['ChilliTenancyService'];

	function UrlService(ChilliTenancyService) {
		var service = {
			getWebAPIUrl: getWebAPIUrl,
			getDocMergeUrl: getDocMergeUrl,
			getSignalRUrl: getSignalRUrl
		};

		var webAPIUrl = '/api';
		var docMergeUrl = 'http://localhost:62594/api';

		return service;

		function getWebAPIUrl() {
		    return webAPIUrl + '/' + ChilliTenancyService.selectedTenancyId;
		}

		function getSignalRUrl() {
		    return '/signalr';
		}

        function getDocMergeUrl() {
            return docMergeUrl;
        }
	}
})();